const easyStart=[
  {
    "id": "1",
    "icon": "/images/icons/2.png",
    "title": "Sign up",
    "link": "/service-details",
    "text": "Are you ready to be among the 380 thousand people who prefer Turkey's leading survey site? Either log in with your Facebook account or register by filling out the membership form."
  },
  {
    "id": "2",
    "icon": "/images/icons/1.png",
    "title": "Participate in Surveys",
    "link": "/service-details",
    "text": "Take your free time and participate in surveys. Don't worry, you don't have to follow it all the time. You will receive a notification when you have a survey."
  },
  {
    "id": "3",
    "icon": "/images/icons/3.png",
    "title": "Earn money",
    "link": "/service-details",
    "text": "Earn up to 20 TL from each survey you participate in. Load TL to your mobile phone with your earnings, transfer money to your bank account. Use it as a gift certificate if you want."
  }
]


export default easyStart